import type from './user-opened-new-recording-config.type';
import createStandardAction from '../../utilities/create-standard-action';

const userOpenedNewRecordingConfig = createStandardAction(type);

export default userOpenedNewRecordingConfig;
